import { colors } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledLinesSkus = styled.div`
  margin: 2rem 0 0.5rem 0;
`

export const Title = styled.div`
  margin-bottom: 1rem;
  font-weight: bold;
  color: ${colors.textLight};
`
